import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@material-ui/core';
import {useMutation} from '@apollo/client';
import {useSnackbar} from 'notistack';
import {useRouter} from 'next/router';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import dayjs from 'dayjs';

import {
  LinkUserDiscordMutation,
  DiscordDisconnectUserMutation
} from 'src/views/AccountSettings/mutations';
import {DiscordIcon} from 'src/views/AccountSettingsNext/icons/DiscordIcon';
import {extendedTypography} from 'src/themes/themeNext/extendedTypography';
import {DiscordSmallIcon} from 'src/views/AccountSettingsNext/icons/DiscordSmallIcon';
import {DiscordAvatarIcon} from 'src/views/AccountSettingsNext/icons/DiscordAvatarIcon';
// import {PointsStarIcon} from 'src/componentsNext/icons/PointsStarIcon';
// import {GiftIcon} from 'src/componentsNext/icons/info/GiftIcon';
// import {AddIcon} from 'src/componentsNext/icons/actions/AddIcon';
// import {EarnDiscordPointsModal} from 'src/componentsNext/EarnDiscordPointsModal';

import {DisconnectDiscordModal} from './DisconnectDiscordModal';

export const useStyles = makeStyles(theme => ({
  settingBox: {
    width: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.colors.blue[700],
    border: `1px solid ${theme.palette.colors.blue[500]}`,
    borderRadius: 8,

    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      flexDirection: 'column',
      gap: theme.spacing(2)
    }
  },
  text: {
    '& p:first-child': {
      color: theme.palette.common.white,
      ...extendedTypography.body1RegularDesktop,

      [theme.breakpoints.down('sm')]: {
        ...extendedTypography.body1RegularMobile
      }
    },
    '& p:last-child': {
      color: theme.palette.colors.blue[50],
      ...extendedTypography.body2RegularDesktop,

      [theme.breakpoints.down('sm')]: {
        ...extendedTypography.body2RegularMobile
      }
    }
  },
  discordButton: {
    width: 'auto',
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.colors.discord,
    color: theme.palette.common.white,

    '&:hover': {
      backgroundColor: theme.palette.colors.discord
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  greyOutlinedButton: {
    width: 160,
    padding: theme.spacing(1.5, 3),
    borderRadius: 4,
    border: `1px solid ${theme.palette.colors.blue[400]}`,
    ...extendedTypography.body2SemiboldDesktop,
    backgroundColor: 'transparent',
    color: theme.palette.colors.blue[50],

    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.colors.blue[50]
    },

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  icon: {
    // padding: theme.spacing(1)
    [theme.breakpoints.down('sm')]: {
      '& svg': {
        width: 96,
        height: 96
      }
    }
  },
  buttons: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 'unset',
      flexDirection: 'column',
      gap: theme.spacing(2)
    },

    '& > button': {
      width: 160,
      minWidth: 160,

      [theme.breakpoints.down('sm')]: {
        width: '100%',
        minWidth: 'unset'
      }
    }
  },
  discordInfoBox: {
    // display: 'flex',
    // alignItems: 'center',
    // gap: theme.spacing(4)
  },
  info: {
    padding: theme.spacing(1.5, 2.5),
    border: `1px solid ${theme.palette.colors.blue[400]}`,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    background: 'rgba(255, 255, 255, 0.05)',

    '& p:first-child': {
      ...extendedTypography.body1MediumDesktop,
      color: theme.palette.common.white
    },
    '& p:last-child': {
      ...extendedTypography.body2RegularDesktop,
      color: theme.palette.colors.grey
    },

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  earnPointsLabel: {
    height: 44,
    display: 'grid',
    gridTemplateColumns: '1fr max-content',
    gap: theme.spacing(1),
    justifyContent: 'center',
    justifyItems: 'center',
    alignItems: 'center',
    borderRadius: 58,
    border: `1px solid ${theme.palette.colors.green[900]}`,
    background: 'rgba(82, 210, 117, 0.05)',
    boxShadow: '0px 0px 8px 0px rgba(82, 210, 117, 0.10)',
    backdropFilter: 'blur(6px)',
    padding: theme.spacing(0, 1.5),
    ...extendedTypography.body1SemiboldDesktop,
    color: theme.palette.common.white,

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  flexRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },

  linkDiscordRow: {
    display: 'flex',
    gap: theme.spacing(3),
    alignItems: 'center',

    '& svg': {
      height: 20,
      width: 20,
      color: theme.palette.colors.green[900]
    },

    [theme.breakpoints.down('sm')]: {
      display: 'contents'
    }
  },
  dividerIcon: {
    width: 1,
    height: 16,
    backgroundColor: theme.palette.colors.green[900],
    opacity: 0.3
  },
  icons: {
    display: 'flex',
    gap: 10,
    alignItems: 'center'
  }
}));

// export const IS_FIRST_TIME_LINK_DISCORD = 'isFirstTimeLink';

// const loadFistTimeLinkFromStorage = () => {
//   if (typeof window === 'undefined') {
//     return undefined;
//   }
//
//   try {
//     return localStorage.getItem(IS_FIRST_TIME_LINK_DISCORD);
//   } catch (e) {
//     console.log('Error on user loading from localStorage: ');
//   }
//
//   return undefined;
// };

const clientId = process.env.DISCORD_CLIENT_ID;
// const clientId = '1349750322460885064';
const redirectPath = '/account/settings';
const redirectUri = process.env.ORIGIN + redirectPath; // Our redirect URI
const discordOauthUrl =
  `https://discord.com/oauth2/authorize?` +
  `client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}` +
  `&response_type=code&scope=email+identify`;

const DiscordSettings = ({customer, updateCustomer}) => {
  const classes = useStyles();
  const router = useRouter();
  const {enqueueSnackbar} = useSnackbar();
  const [openDiscordModal, setOpenDiscordModal] = useState(false);
  // const [openEarnedPointsModal, setOpenEarnedPointsModal] = useState(false);
  // const {user} = useStorefrontData();

  const [linkDiscordMutation] = useMutation(LinkUserDiscordMutation);
  const [disconnectDiscordMutation] = useMutation(
    DiscordDisconnectUserMutation
  );

  useEffect(() => {
    const linkDiscord = async () => {
      if (router.query.code) {
        const {data} = await linkDiscordMutation({
          variables: {
            code: router.query.code,
            redirectPath: redirectPath
          }
        });

        // const user = data.discordLinkUser.user;
        const errors = data.discordLinkUser.errors;

        if (errors.length > 0) {
          errors.map(error => {
            enqueueSnackbar(error.message, {variant: 'error'});
          });
          router.push(`/account/settings`);
          return null;
        }

        updateCustomer({...customer, discordInfo: data.discordLinkUser.user});

        // const isFirstLoginViaDiscord = loadFistTimeLinkFromStorage();

        // if (customer?.isFirstTimeLink && !isFirstLoginViaDiscord) {
        //   localStorage.setItem(IS_FIRST_TIME_LINK_DISCORD, 1);
        //   setOpenEarnedPointsModal(true);
        // }

        router.push(`/account/settings`);
        enqueueSnackbar('Discord was linked successfully!', {
          variant: 'success'
        });
      }
    };

    linkDiscord();
  }, [customer, linkDiscordMutation, router]);

  const handleToggleDiscordModal = () => {
    setOpenDiscordModal(prev => !prev);
  };

  const handleDiscordLink = () => {
    window.location.href = discordOauthUrl;
    // window.open(
    //   discordOauthUrl,
    //   '_blank' // <- This is what makes it open in a new window.
    // );
  };

  const handleDiscordDisconnect = async () => {
    const {data} = await disconnectDiscordMutation({
      variables: {
        id: customer?.discordInfo?.id
      }
    });
    const errors = data.discordDisconnectUser.errors;

    if (errors.length > 0) {
      errors.map(error => enqueueSnackbar(error.message, {variant: 'error'}));
      router.push(`/account/settings`);
      return null;
    }

    updateCustomer({...customer, discordInfo: null});

    // setDiscordUser(null);
    router.push(`/account/settings`);
    enqueueSnackbar('Discord was disconnected successfully!', {
      variant: 'success'
    });
  };

  return (
    <>
      <div className={classes.settingBox}>
        <div className={classes.icon}>
          <DiscordIcon />
        </div>
        <div className={classes.text}>
          <Typography>Link Your Discord</Typography>
          <Typography>
            {customer?.discordInfo
              ? 'Well done! Your Discord is linked.'
              : 'Connect your Discord to unlock server access and receive automated roles instantly.'}
          </Typography>
        </div>

        <div className={classes.buttons}>
          {customer?.discordInfo ? (
            <>
              <div className={classes.info}>
                <DiscordAvatarIcon />
                <div>
                  <Typography>{customer.discordInfo.username}</Typography>
                  <Typography>
                    Linked:{' '}
                    {customer.discordInfo.linkDate &&
                      dayjs(customer.discordInfo.linkDate).format(
                        'MMMM D, YYYY'
                      )}
                  </Typography>
                </div>
              </div>
              <Button
                variant='outlined'
                color='primary'
                size='small'
                onClick={handleToggleDiscordModal}
              >
                Disconnect
              </Button>
            </>
          ) : (
            <div className={classes.linkDiscordRow}>
              {/*{customer?.isFirstTimeLink && (*/}
              {/*  <div className={classes.earnPointsLabel}>*/}
              {/*    <div className={classes.flexRow}>*/}
              {/*      <AddIcon /> 50 Points <PointsStarIcon />*/}
              {/*    </div>*/}
              {/*    <div className={classes.flexRow}>*/}
              {/*      <div className={classes.dividerIcon} /> <GiftIcon />*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*)}*/}
              <Button
                size='small'
                variant='contained'
                classes={{root: classes.discordButton}}
                onClick={handleDiscordLink}
                startIcon={<DiscordSmallIcon />}
              >
                Link Discord
              </Button>
            </div>
          )}
        </div>
      </div>
      <DisconnectDiscordModal
        onClose={handleToggleDiscordModal}
        open={openDiscordModal}
        onDisconnect={handleDiscordDisconnect}
      />
      {/*<EarnDiscordPointsModal*/}
      {/*  open={openEarnedPointsModal}*/}
      {/*  onClose={() => setOpenEarnedPointsModal(false)}*/}
      {/*/>*/}
    </>
  );
};

DiscordSettings.propTypes = {
  customer: PropTypes.object.isRequired
};

export default DiscordSettings;
